import React, { Component } from 'react';
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as FallingQuotesActions from './redux/FallingQuotesActions';
import auth from '../../libCustom/auth';
import moment from 'moment';
import feathers from '../../feathers';
class FallingQuotesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  async componentWillMount() {
    let fallingQuotesResult = await feathers.service('falling-quotes').find({
      query: {
        franchiseId: auth.getCurrentUser().franchiseId,
      },
    });
    this.setState({
      data: fallingQuotesResult.data,
    });
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    const { FallingQuotes } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Cotizaciones caídas'}{' '}
                    <div className="pull-right header-table">
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={FallingQuotes.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={this.state.data}
                    page={FallingQuotes.table.page}
                    sorted={FallingQuotes.table.sorted}
                    filtered={FallingQuotes.table.filtered}
                    pageSize={FallingQuotes.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Fecha',
                        accessor: 'createdAt',
                        sortable: true,
                        filterable: false,
                        minWidth: 60,
                        Cell: (props) => (
                          // we've added some custom button actions
                          <div>
                            {props.original.createdAt
                              ? moment(props.original.createdAt).format('ll')
                              : ''}
                          </div>
                        ),
                      },
                      {
                        Header: 'Causa',
                        accessor: 'reason.name',
                        sortable: true,
                        filterable: false,
                        minWidth: 120,
                      },
                      {
                        Header: 'Descripción',
                        accessor: 'description',
                        headerStyle: { textAlign: 'left' },
                        style: { textAlign: 'left' },
                        sortable: true,
                        filterable: false,
                        minWidth: 120,
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    FallingQuotes: state.FallingQuotes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(FallingQuotesActions, dispatch);
};

const FallingQuotesConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FallingQuotesIndex);

export default FallingQuotesConnect;



// WEBPACK FOOTER //
// ./src/views/FallingQuotes/FallingQuotesIndex.jsx